<template>
  <div>
    <h2>Segmentación</h2>
    <Spinner id="spinner" :is-loading="isLoading" />
    <div v-if="!isLoading">
      <b-collapse
        v-for="(value, key, index) of riskPoliciesMap"
        :key="index"
        class="card"
        animation="slide"
        :open="expandedCountry === key"
        @open="expandedCountry = key">
        <template #trigger="props">
          <div class="card-header" role="button">
            <p class="card-header-title">{{ countryDictionary[key] }}</p>
            <a class="card-header-icon"><span class="fa fa-chevron-down transition-fast" :class="{ rotate: props.open }" /></a>
          </div>
        </template>
        <div class="card-content">
          <b-collapse
            v-for="(riskPolicy, i) in value"
            :key="riskPolicy.subSegment"
            class="card"
            animation="slide"
            :open="expandedRiskPolicySubSegment === riskPolicy.subSegment"
            @open="expandedRiskPolicySubSegment = riskPolicy.subSegment">
            <template #trigger="props">
              <div class="card-header" role="button">
                <p class="card-header-title">{{ riskPolicy.subSegment }} ({{ riskPolicy.subSegmentDescription }})</p>
                <a class="card-header-icon">
                  <span class="fa fa-chevron-down transition-fast" :class="{ rotate: props.open }" />
                </a>
              </div>
            </template>
            <RiskPolicy :risk-policy="riskPolicy" :country="key" @updated="riskPoliciesMap[key][i] = $event" />
          </b-collapse>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<script>
import Spinner from '@/ui/components/Spinner.vue';
import RiskPolicy from '@/ui/components/internal/settings/RiskPolicy.vue';
import { getRiskPolicies } from '@/application/services/api-clients/risk-policies';

export default {
  components: { Spinner, RiskPolicy },
  data() {
    return {
      isLoading: true,
      riskPoliciesMap: { cl: [], pe: [], br: [] },
      expandedCountry: '',
      expandedRiskPolicySubSegment: '',
      countryDictionary: { cl: 'Chile', pe: 'Peru', br: 'Brasil' }
    };
  },
  async mounted() {
    const [riskPoliciesCL, riskPoliciesPE, riskPoliciesBR] = await Promise.all(['cl', 'pe', 'br'].map(x => getRiskPolicies(x)));
    this.riskPoliciesMap = { cl: riskPoliciesCL, pe: riskPoliciesPE, br: riskPoliciesBR };
    this.isLoading = false;
  }
};
</script>
<style>
.rotate {
  transform: rotate(180deg);
}
</style>
